import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icon, Menu } from 'semantic-ui-react';
import findResult from '@/utils/resultsHelper';
import { states, updateStates } from '@/constants/lifecycle';
import { archivedIcon } from '@/constants/images';
import WarningPopup from '@/components/WarningPopup';
import { showArchiveUser } from '../actions';

const UserArchiveAction = ({
  archived,
  category,
  code,
  disabled,
  fullscreen,
  hasLabels,
  isCurrentUser,
  showArchive,
}) => {
  const intl = useIntl();
  return (
    <WarningPopup disabled={!isCurrentUser} position="right center">
      <Menu.Item
        name={archived ? 'restore' : 'archive'}
        title={intl.formatMessage({ id: archived ? 'status.restore.hover' : 'status.archive.hover' })}
        onClick={disabled ? undefined : () => showArchive(category, code)}
        className="aridhia-user-archive-action aridhia-ribbon-menu"
        disabled={disabled}
        rel="noopener noreferrer"
      >
        {!fullscreen && (<Icon name={archivedIcon(!archived)} />)}
        {hasLabels && (<FormattedMessage id={archived ? 'actions.restore' : 'actions.archive'} />)}
      </Menu.Item>
    </WarningPopup>
  );
};

const mapStateToProps = ({
  auth: { users, currentUser },
  layout: { labels, fullscreen },
}, { category, code }) => {
  const item = findResult(users, category, code) || { ...updateStates, archived: false };

  return ({
    archived: item.archived,
    disabled: item.updateStatus === states.PENDING,
    fullscreen,
    hasLabels: labels || fullscreen,
    isCurrentUser: code === currentUser.id,
  });
};

const mapDispatchToProps = {
  showArchive: showArchiveUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserArchiveAction);
